import React from 'react';
import PropTypes from 'prop-types';

class Loader extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="level">
        <div className="level-left">
          <div className="level-item">
            <div className="loader" />
          </div>
          <div className="level-item">{this.props.text}</div>
        </div>
      </div>
    );
  }
}

Loader.propTypes = {
  text: PropTypes.string,
};

export default Loader;
